import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Icon from "components/AppIcon";
import { useNavigation } from "components/ui/NavigationStateManager";
import StoreSelector from "components/ui/StoreSelector";
import WelcomeSection from "./components/WelcomeSection";
import ContinueButton from "./components/ContinueButton";

const StoreSelectionLandingPage = () => {
  const navigate = useNavigate();
  const {
    currentStore,
    anonymousMode,
    handleStoreSelection,
    handleNavigationStep,
    getAnonymousName,
    loader,
  } = useNavigation();

  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handleContinue = async () => {
    if (!currentStore) return;

    setIsLoading(true);

    await new Promise((resolve) => setTimeout(resolve, 1500));

    handleNavigationStep(1, {
      action: "proceed_to_products",
      store: currentStore,
    });

    setIsLoading(false);
    navigate("/product-listing-page");
  };

  const handleStoreSelect = (store) => {
    handleStoreSelection(store);
  };

  return (
    <div className="bg-background">
      <div className="container-app section-spacing">
        <div className="max-w-4xl mx-auto">
          <WelcomeSection />

          <div className="bg-surface rounded-xl shadow-lg border border-border p-4 mb-8">
            <div className="max-w-2xl mx-auto">
              <div className="mb-8">
                <div className="flex justify-center">
                  <label className="block text-sm font-medium text-text-primary mb-3">
                    <button
                      disabled={loader}
                      onClick={() => setOpenModal(true)}
                      className="px-4 py-2 text-sm font-medium text-primary border border-primary rounded-md hover:bg-primary-50 transition-smooth focus-ring"
                    >
                      {currentStore ? "Change Store" : "Select Store"}
                    </button>
                  </label>
                </div>

                <div className="w-full flex items-center justify-between p-4 text-left bg-surface border border-border rounded-lg mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center">
                      <Icon
                        name="Building2"
                        size={20}
                        className="text-primary"
                      />
                    </div>
                    <div>
                      <div className="font-medium text-text-primary">
                        {currentStore ? (
                          <>
                            {anonymousMode
                              ? getAnonymousName(currentStore.iTenantId)
                              : currentStore.sBrandName}
                            <span className="ml-2 px-2 py-1 text-xs rounded-full bg-success-100 text-success-700">
                              Active
                            </span>
                          </>
                        ) : (
                          "Select a store to begin testing"
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <StoreSelector
                  variant="full"
                  onStoreSelect={handleStoreSelect}
                  className="w-full"
                  openModal={openModal}
                  setOpenModal={setOpenModal}
                />
              </div>

              <ContinueButton
                disabled={!currentStore}
                loading={isLoading}
                onClick={handleContinue}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreSelectionLandingPage;
